import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1vgbWGtLA-uHRcrSmPI8oC_SGDyafdP0",
  authDomain: "aishoutouts.firebaseapp.com",
  projectId: "aishoutouts",
  storageBucket: "aishoutouts.appspot.com",
  messagingSenderId: "1096747171580",
  appId: "1:1096747171580:web:cd13f1a149487f17e0e179",
  measurementId: "G-91BWCJ4R9D",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export { firebase };
